import { eventMapper, pageMapper } from './dataMapper';

const debugLog = (message, data) => {
  let debug = document.cookie.indexOf('utagdb=true') > -1;
  if (debug) {
    console.log(message, data);
  }
}

function sendEventToTealium(data) {
  if (window.utag != null) {
    window.utag.link(data);
    debugLog('sc-analytics-api: utag.link called with payload:', data);
  } else {
    debugLog('sc-analytics-api: no pageview sent because utag.js wasn\'t loaded (yet)', data);
  }
}

function sendPageViewToTealium(data) {
  if (window.utag != null) {
    window.utag.view(data);
    debugLog('sc-analytics-api: utag.view called with payload:', data);
  } else {
    debugLog('sc-analytics-api: no pageview sent because utag.js wasn\'t loaded (yet)', data);
  }
}

const ScAnalyticsApi = {
  eventTrack: function (trackingData) {
    const eventTrack = eventMapper(trackingData);
    if (eventTrack) {
      sendEventToTealium(eventTrack);
    }
  },
  pageTrack: function (trackingData) {
    const pageTrack = pageMapper(trackingData);
    if (pageTrack) {
      sendPageViewToTealium(pageTrack);
    }
  }
}

export default ScAnalyticsApi;
